module.exports = function nodeTypeExists(type, nodesConfig){
	const exists = nodesConfig.find(config => type === config.type);
	return typeof exists !== 'undefined';
}
